import React, { useState, useEffect } from "react";
import { Modal, message } from "antd";
import http from "@/utils/http";
import api from "@/utils/api";
import { CustomTable } from "@/hocComponents";
import commonFn from "@/utils/commonFn";

const PropDetailDrawer = ({ 
  visible, 
  onClose, 
  drawerType, 
  record, 
}) => {
  const [loading, setLoading] = useState(false);
  const [detailData, setDetailData] = useState([]);
  const [propTypeOptions, setPropTypeOptions] = useState([]);
  const [tableHead, setTableHead] = useState({});
  const [detail,setDetail]= useState([]);
  const fetchPropertyTypes = async () => {
    try {
      const res = await http.get(api.getPropTypeList);
      if (res?.code === "1") {
        const options = res.data.map((item) => ({
          label: item?.name,
          value: item?.code,
        }));
        setPropTypeOptions(options);
      }
    } catch (error) {
      console.error("Failed to load property types:", error);
    }
  };

  const getTableListFn = async (page, count, tableHeadTemp) => {
    if (!record) return;

    setLoading(true);

    try {
      const params = {
        page: page || 1,
        count: count || 1000,
        prop: tableHeadTemp?.prop || "",
        address: tableHeadTemp?.address || "",
        propType: tableHeadTemp?.propType || "",
        orderField: tableHeadTemp?.orderField || "",
        orderType: tableHeadTemp?.orderType || "",
      };

      if (drawerType === "city") {
        params.city = record.city || record.name;
      } else if (drawerType === "area") {
        params.city = "";
        params.groupId = record.id;
        params.supervisorId = "";
      } else if (drawerType === "supervisor") {
        params.city = "";
        params.groupId = "";
        params.supervisorId = record.id;
      }

      const res = await http.post(api.getSnapshotByProperty, params);

      if (res?.code === "1" && res?.data) {
        setDetailData(res.data.list || []);
        setDetail(res.data)
      } else {
        message.error(res?.msg || "Failed to fetch detail data");
      }

    } catch (error) {
      console.error("Error fetching detail data:", error);
      message.error("Failed to fetch detail data");
    } finally {
      setLoading(false);
    }
  };

  const tableFilterFn = (event, key, type = "Input") => {
    commonFn.tableFilterFn({
      event,
      key,
      type,
      setTableHead,
      getTableListFn,
      pageSize: 1000,
    });
  };

  useEffect(() => {
    if (visible && record) {
      fetchPropertyTypes();
      getTableListFn();
    }
  }, [visible, record, drawerType]);

  const handleClose = () => {
    setDetailData([]);
    setTableHead({});
    onClose();
  };

  const getDetailColumns = () => {
    const columns = [
      {
        title: 'Property',
        dataIndex: 'prop',
        key: 'prop',
        align: 'center',
        titleType: "Input",
        isSorter:true,
        onChange: (e) => tableFilterFn(e, "prop"),
      },
      {
        title: 'Address',
        dataIndex: 'address',
        key: 'address',
        align: 'center',
        titleType: "Input",
        width: 220,
        isSorter:true,
        onChange: (e) => tableFilterFn(e, "address"),
      },
      {
        title: 'Property Type',
        dataIndex: 'propType',
        key: 'propType',
        align: 'center',
        titleType: "Select",
        isSorter:true,
        selectOptions: propTypeOptions,
        onChange: (value) => tableFilterFn(value, "propType", "Select"),
      },
      {
        title: 'Units',
        dataIndex: 'units',
        key: 'units',
        align: 'center',
        width: 80,
        isSorter:true,
      },
      {
        title: 'Vacant Units',
        dataIndex: 'vacantUnits',
        key: 'vacantUnits',
        align: 'center',
        width: 80,
      },
      {
        title: 'Eviction Units',
        dataIndex: 'evictionUnits',
        key: 'evictionUnits',
        align: 'center',
        width: 80,
      },
    ];

    return columns;
  };

  const getModalTitle = () => {
    if (!record) return 'Unit Details';
    
    const typeMap = {
      'city': `City Units - ${record.name || record.city}`,
      'area': `Area Units - ${record.name}`,
      'supervisor': `Supervisor Units - ${record.name || record.supervisor}`,
      'snapshot': 'Unit Details',
    };
  const baseTitle = typeMap[drawerType] || 'Unit Details';
  const summary = detail?.summary;
     
  if (summary) {
    const parts = [];
    if (summary.totalProperties) parts.push(`${summary.totalProperties} Properties`);
    if (summary.totalUnits) parts.push(`${summary.totalUnits} Units`);
    if (parts.length > 0) {
      return `${baseTitle} - ${parts.join(', ')}`;
    }
  }
  
  return baseTitle;
  };

  return (
    <Modal
      title={getModalTitle()}
      open={visible}
      onCancel={handleClose}
      footer={null}
      width="50%"
      destroyOnClose
      maskClosable={false}
      centered
      styles={{ body: { padding: '16px 0' } }}
    >
      <CustomTable
        columns={getDetailColumns()}
        tableList={detailData}
        tableLoading={loading}
        rowKey="unitId"
        size="small"
        setTableHead={setTableHead}
        getTableListFn={getTableListFn}
        pagination={false}
        scroll={{ x: "max-content", y: "calc(80vh - 200px)" }}
      />
    </Modal>
  );
};

export default PropDetailDrawer;
